/* @flow weak */
import configureReducer from './reducer'
import configureMiddleware from './middleware'
import { applyMiddleware, createStore, compose } from 'redux'

const configureStore = options => {
  const { config, platformDeps = {}, platformMiddleware = [] } = options

  const reducer = configureReducer({ config })

  const middleware = configureMiddleware(
    config,
    platformDeps,
    platformMiddleware
  )

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const store = createStore(
    reducer,
    { config },
    composeEnhancers(applyMiddleware(...middleware))
  )

  // Enable hot reloading for reducers.
  if (module.hot) {
    const replaceReducer = configureReducer =>
      store.replaceReducer(configureReducer(config))
    module.hot.accept('./reducer', () => {
      replaceReducer(require('./reducer'))
    })
  }

  return store
}

export default configureStore
